var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partsPrice-container"},[_vm._v("配件价格")])}
var staticRenderFns = []

export { render, staticRenderFns }